<template>
  <!-- Kontener pojedynczego wyświetlania filtra -->
  <div class="filter d-flex">
    <!-- Nazwa filtra, przetłumaczona przy pomocy i18n -->
    <div class="name">{{ $t(name) }}</div>
    <!-- Symbol operatora (np. '=', '>=') wyświetlany tylko jeżeli jest przekazany -->
    <span v-if="symbol">{{ symbol }}</span>
    <!-- Pole input z wartością filtra:
         - name atrybutu odpowiada kluczowi w store.filters
         - jeśli nazwa filtra to 'registration', wartość automatycznie zamieniana na wielkie litery
         - pole jest zawsze zablokowane (disabled), bo to tylko widok -->
    <input
      :name="fieldName"
      :value="name === 'registration' ? value.toUpperCase() : value"
      :disabled="true"
    />
  </div>
</template>

<script>
export default {
  // Unikalna nazwa komponentu
  name: "SingleFilterView",
  // Lista właściwości przekazywanych z komponentu nadrzędnego:
  // - name: klucz filtra i tekst do tłumaczenia
  // - symbol: operator do wyświetlenia (opcjonalny)
  // - fieldName: nazwa pola w store.filters
  // - value: aktualna wartość filtra
  props: ["name", "symbol", "fieldName", "value"],
};
</script>

<style scoped>
/* Styl etykiety nazwy filtra */
.name {
  width: 100px;     /* Szerokość kolumny z nazwą filtra */
  padding: 15px 0;  /* Wertykalny padding dla wyrównania */
}

/* Styl pola input wyświetlającego wartość filtra */
input {
  width: 100px;       /* Szerokość pola */
  text-align: center; /* Wyśrodkowanie tekstu */
  margin: 5px;        /* Margines wokół pola */
}
</style>
